import React, { Component } from 'react'
import ContentLayout from '../../components/ContentLayout'
import ContentMain from '../../components/ContentMain'
import UserSubscriptionLayout from '../../partials/UserSubscriptionLayout'

interface Props {}

export default class UserSubscriptions extends Component<Props> {
  render () {
    return (
      <ContentLayout>
        <ContentMain layout="twoThird">
          <UserSubscriptionLayout />
        </ContentMain>
      </ContentLayout>
    )
  }
}
